import React, { useState, useEffect } from 'react'
import EstrellaRating from './EstrellaRating'
import { reviewsService } from '../../services/reviewsService'

const FormularioCalificacion = ({ entityId, entityType, userId, entityName, entityArtist, entityAlbum, entityImage }) => {
  const [calificacion, setCalificacion] = useState(0)
  const [titulo, setTitulo] = useState('')
  const [comentario, setComentario] = useState('')
  const [mensaje, setMensaje] = useState('')
  const [reviewExistente, setReviewExistente] = useState(null)

  useEffect(() => {
    cargarReviewExistente()
  }, [userId, entityId, entityType])

  const cargarReviewExistente = async () => {
    if (!userId) return
    try {
      const review = await reviewsService.obtenerReviewDeUsuario(userId, entityType, entityId)
      if (review) {
        setReviewExistente(review)
        setCalificacion(review.rating)
        setTitulo(review.title || '')
        setComentario(review.content || '')
      }
    } catch (error) {
      console.error('Error cargando review existente:', error)
    }
  }

  const manejarEnvio = async (e) => {
    e.preventDefault()
    
    if (!userId) {
      setMensaje('Debes iniciar sesión para calificar')
      return
    }

    if (calificacion === 0) {
      setMensaje('Debes seleccionar una calificación')
      return
    }

    try {
      await reviewsService.crearReview(
        userId,
        entityType,
        entityId,
        calificacion,
        titulo,
        comentario,
        {
          name: entityName,
          artist: entityArtist,
          album: entityAlbum,
          image: entityImage
        }
      )
      
      setMensaje(reviewExistente ? '¡Review actualizado!' : '¡Review publicado!')
      setTimeout(() => setMensaje(''), 3000)
      
      cargarReviewExistente()
    } catch (error) {
      console.error('Error guardando review:', error)
      setMensaje('Error al guardar el review')
    }
  }

  return (
    <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb'
    }}>
      <h3 style={{
        fontSize: '20px',
        fontWeight: '600',
        marginBottom: '16px',
        color: '#111827'
      }}>
        {reviewExistente ? 'Editar tu review' : 'Calificar'}
      </h3>

      <form onSubmit={manejarEnvio}>
        <div style={{marginBottom: '16px'}}>
          <label style={{
            display: 'block',
            fontWeight: '500',
            marginBottom: '8px',
            color: '#374151'
          }}>
            Calificación *
          </label>
          <EstrellaRating 
            calificacion={calificacion}
            alCambiar={setCalificacion}
          />
        </div>

        <div style={{marginBottom: '16px'}}>
          <label style={{
            display: 'block',
            fontWeight: '500',
            marginBottom: '8px',
            color: '#374151'
          }}>
            Título de tu review
          </label>
          <input
            type="text"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            placeholder="Ej: ¡Excelente canción!"
            style={{
              width: '100%',
              padding: '8px 12px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px'
            }}
          />
        </div>

        <div style={{marginBottom: '16px'}}>
          <label style={{
            display: 'block',
            fontWeight: '500',
            marginBottom: '8px',
            color: '#374151'
          }}>
            Tu opinión detallada
          </label>
          <textarea
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
            placeholder="Escribe tu opinión detallada..."
            rows="4"
            style={{
              width: '100%',
              padding: '8px 12px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              resize: 'vertical'
            }}
          />
        </div>

        <button
          type="submit"
          style={{
            backgroundColor: '#8b5cf6',
            color: 'white',
            padding: '10px 20px',
            borderRadius: '6px',
            border: 'none',
            fontWeight: '600',
            cursor: 'pointer',
            width: '100%'
          }}
        >
          {reviewExistente ? 'Actualizar Review' : 'Publicar Review'}
        </button>

        {mensaje && (
          <div style={{
            marginTop: '12px',
            padding: '12px',
            backgroundColor: mensaje.includes('Error') ? '#fee2e2' : '#d1fae5',
            color: mensaje.includes('Error') ? '#991b1b' : '#065f46',
            borderRadius: '6px',
            fontSize: '14px'
          }}>
            {mensaje}
          </div>
        )}
      </form>
    </div>
  )
}

export default FormularioCalificacion